import React from 'react';
import {useHistory} from 'react-router-dom';
import {recordProxy, getUrlValue} from '../../util';

import topLogo from './imgs/top-logo.png';

import './index.less';
export default function ScanCodePage() {
    const history = useHistory();
    const pageTitle = decodeURIComponent(getUrlValue('page_title') || '暂无数据');
    const companyName = decodeURIComponent(getUrlValue('company_name') || '');
    const isPay = getUrlValue('is_pay') === 'true';

    const onLogoClick = () => {
        history.push('/');
        recordProxy('scanCodePage', 'click', 'topLogo');
    };

    const getQrcodeSrc = () => {
        const qrCodeUrl = (
            window.location.host.indexOf(':8066') > -1
            || window.location.host.indexOf('safe-mobsec06.bcc-bdbl.baidu.com') > -1)
            ? 'http://safe-mobsec06.bcc-bdbl.baidu.com:8879' : 'https://mhaoma.baidu.com';

        const businessPath = `/pages/business-card/business-card?company_name=${companyName}`
            + `&showtitle=${pageTitle}&scan=true&srcid=znt`;
        const normalPath = `/pages/search-result/search-result?search=${pageTitle}&scan=true&srcid=znt`;

        const qrSrc = window.location.origin
            + '/api/v1/qr_code?url='
            + encodeURIComponent(
                `${qrCodeUrl}${(isPay && companyName) ? businessPath : normalPath}`);
        return qrSrc;
    };

    return (<div className="scan-code-page">
        <div>
            <img className="top-logo" src={topLogo} alt="top-logo" onClick={onLogoClick}/>
            <div className="right-bg"></div>
        </div>
        <div className="center-content">
            <div className="qrcode-bg">
                <div className="qrcode-wrapper">
                    <img src={getQrcodeSrc()} />
                </div>
            </div>
            <div>
                <div className="title">{pageTitle}</div>
                <div className="tip">手机扫一扫二维码，可快速选择号码进行拨打</div>
            </div>
        </div>
        <div className="bottom-bg"></div>
    </div>);
}